import {
    makeStyles,
} from 'app/tss'

const addressDetails = 'addressDetails'
const communication = 'communication'
const customerSalesArea = 'customerSalesArea'
const salesAreaTax = 'salesAreaTax'
const abacusSettings = 'abacusSettings'

const useStyles = makeStyles()((theme) => {
    return {
        gridWrapperBilling: {
            display: 'grid',
            gridGap: theme.spacing(1.5),
            gridTemplateAreas: `
            " ${addressDetails} ${addressDetails} ${communication} ${communication}"
            " ${customerSalesArea} ${customerSalesArea} ${salesAreaTax} ${salesAreaTax}"
            " ${abacusSettings} ${abacusSettings} ${abacusSettings} ${abacusSettings}"
            `,
            gridTemplateColumns: 'repeat(4, 1fr)',
        },
        addressDetails: {
            gridArea: addressDetails,
        },
        communication: {
            gridArea: communication,
        },
        customerSalesArea: {
            gridArea: customerSalesArea,
        },
        salesAreaTax: {
            gridArea: salesAreaTax,
        },
        abacusSettings: {
            gridArea: abacusSettings,
        },
    }
})

export default useStyles
